export default "__VITE_ASSET__DPF6AKNn__"